const BASIC_API_URL = process.env.REACT_APP_BASIC_API_URL,
	API_URL_FUNCTION_UTILS = process.env.REACT_APP_API_URL_FUNCTION_UTILS,
	IMAGE_API_URI = process.env.REACT_APP_IMAGE_API_URI,
	REPORT_API_URI = process.env.REACT_APP_API_REPORT_API_URI,
	REPORT_PLANNING_API_URI = process.env.REACT_APP_API_REPORT_PLANNING_API_URI;
export const getImageByModule = (tokenUserCurent, idProduct, module) => {
	return (
		BASIC_API_URL +
		API_URL_FUNCTION_UTILS +
		IMAGE_API_URI +
		`${module}/${idProduct}?token=${tokenUserCurent}`
	);
};

export const getReport = (tokenUserCurent, idProduct, module) => {
	return (
		BASIC_API_URL +
		API_URL_FUNCTION_UTILS +
		REPORT_API_URI +
		`${module}/${idProduct}?token=${tokenUserCurent}`
	);
};

export const getReportProduction = (tokenUserCurent, idProduct, module, fab) => {
	return (
		BASIC_API_URL +
		API_URL_FUNCTION_UTILS +
		REPORT_API_URI +
		`${module}/${idProduct}?fab=${fab}&token=${tokenUserCurent}`
	);
};
export const getReportPlanning = (tokenUserCurent, idProduct) => {
	return (
		BASIC_API_URL +
		API_URL_FUNCTION_UTILS +
		REPORT_PLANNING_API_URI +
		`${idProduct}?token=${tokenUserCurent}`
	);
};

export const formatDate = (d = new Date()) => {
	//var d = new Date;
	const padLeft = function (number, base, chr) {
		var len = String(base || 10).length - String(number).length + 1;
		return len > 0 ? new Array(len).join(chr || '0') + number : number;
	};
	const dformat =
		[d.getFullYear(), padLeft(d.getMonth() + 1), padLeft(d.getDate())].join('-') +
		' ' +
		[padLeft(d.getHours()), padLeft(d.getMinutes()), padLeft(d.getSeconds())].join(':');
	return dformat;
};

export function getPreviousDay(date = new Date()) {
	const previous = new Date(date.getTime());
	previous.setDate(date.getDate() - 1);

	return previous;
}

export const convertURL = async (url, name, fnSuccess, fnError = () => { }) => {
	try {
		const response = await fetch(url);
		const blob = await response.blob();

		const file = new File([blob], name + '.pdf', {
			type: 'application/pdf',
		});

		fnSuccess(file);
	} catch (error) {
		fnError(error);
	}
};

export const convertIMG = async (url, name, fnSuccess, fnError = () => { }) => {
	try {
		const response = await fetch(url);
		console.log('url', url);
		const blob = await response.blob();
		const img = new File([blob], name + '.png', {
			type: 'image/png',
		});

		fnSuccess(img);
	} catch (error) {
		fnError(error);
	}
};

export function capitalizeWords(str) {
	return str.replace(/\b\w/g, (match) => match.toUpperCase());
}
export const ImageIcon = (fileType) => {
	const image = ['image', 'jpeg', 'jpg', 'png', 'ico'];
	const pdf = ['application', 'pdf'];
	const video = [, 'video', 'mp4', 'mov', 'mkv'];
	if (image.some((type) => fileType.includes(type))) {
		return 'InsertPhoto';
	} else if (video.some((type) => fileType.includes(type))) {
		return 'OndemandVideo';
	} else if (pdf.some((type) => fileType.includes(type))) {
		return 'PictureAsPdf';
	} else {
		return 'AttachFile';
	}
};
